import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Language } from 'src/models/models';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageService extends BaseService<Language, Language> {

  constructor(protected override http: HttpClient) {
    super(http, 'languages');
  }

}
